<template>
    <clean-layout>
        <main role="main">
            <div class="container">
                <div class="row margin-y-5">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto text-center">
                        <h1 class="login-title font-poppins font-weight-light color-light-blue">
                            {{ Lang.get('employerdashboard::pages/auth/login.title') }}</h1>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto">
                        <flash-messages :hideErrors="true"></flash-messages>
                    </div>
                    <div class="col-12 col-md-10 col-lg-7 mx-auto">
                        <div class="card shadow border-0 border-radius-16">
                            <AuthTabPanel>
                                <AuthTabPane
                                    :active="true"
                                    aria-label="employer-tab"
                                    id="employer"
                                >
                                    <div v-if="this.resetMessage" class="alert alert-success">
                                        {{ resetMessage }}
                                    </div>

                                    <p class="font-poppins font-weight-light color-dark-blue">
                                        {{ Lang.get('employerdashboard::pages/auth/login.employer_tab.intro') }}
                                        <a href="https://deleerrekening.nl/aanmelden"
                                           class="font-weight-medium color-dark-blue"><u>{{
                                                Lang.get('employerdashboard::pages/auth/login.employer_tab.sign_up_as')
                                            }}</u></a>
                                    </p>
                                    <form @submit.prevent="submit">

                                        <div class="mt-4">
                                            <template v-if="twoFactorLogin">
                                                <div class="form-group">
                                                    <text-input
                                                        v-model="form.code"
                                                        :placeholder="Lang.get('employerdashboard::shared.placeholder.2fa_code')"
                                                        ref="codeInput"
                                                        id="code"
                                                        type="text"
                                                        :label="Lang.get('employerdashboard::pages/auth/login.employer_tab.labels.code')"
                                                        autofocus
                                                        autocapitalize="off"
                                                    />
                                                </div>
                                            </template>

                                            <template v-else>
                                                <div class="form-group">
                                                    <text-input
                                                        v-model="form.email"
                                                        id="employerEmail"
                                                        type="email"
                                                        :label="Lang.get('employerdashboard::pages/auth/login.employer_tab.labels.email')"
                                                        autocomplete="username"
                                                        autofocus autocapitalize="off"/>
                                                </div>
                                                <div class="form-group mt-4">
                                                    <text-input
                                                        v-model="form.password"
                                                        class="mt-6"
                                                        :label="Lang.get('employerdashboard::pages/auth/login.employer_tab.labels.password')"
                                                        type="password"
                                                        autocomplete="current-password"/>
                                                </div>
                                            </template>
                                        </div>

                                        <div class="mt-4" v-if="this.errors">
                                            <div
                                                class="alert alert-danger alert-danger-icon font-poppins font-weight-light color-red"
                                                role="alert"
                                                v-if="(this.errors.email || this.errors.error) && !this.errors.maxAttempts">
                                                {{ Lang.get('employerdashboard::pages/auth/login.login_failed') }}
                                            </div>
                                            <div
                                                class="alert alert-danger alert-danger-icon font-poppins font-weight-light color-red"
                                                role="alert"
                                                v-if="(this.errors.code) && !this.errors.maxAttempts">
                                                {{ this.errors.code[0] }}
                                            </div>
                                            <div
                                                class="alert alert-danger alert-danger-icon font-poppins font-weight-light color-red"
                                                role="alert" v-if="this.errors.maxAttempts">
                                                {{ this.errors.maxAttempts[0] }}
                                            </div>
                                        </div>

                                        <div class="mt-4 form-check" v-if="!twoFactorLogin">
                                            <input type="checkbox" class="form-check-input" id="employerRemember"
                                                   v-model="form.remember">
                                            <label class="form-check-label font-poppins color-dark-blue"
                                                   for="employerRemember">{{
                                                    Lang.get('employerdashboard::pages/auth/login.remember_me')
                                                }}</label>
                                        </div>

                                        <div class="row mt-4">
                                            <div class="col-12 col-lg-4">
                                                <button type="submit"
                                                        class="btn btn-primary btn-orange font-poppins font-weight-bold color-white border-radius-19 px-5">
                                                    {{ Lang.get('employerdashboard::pages/auth/login.sign_in') }}
                                                </button>
                                            </div>
                                            <div v-if="twoFactorLogin" class="col-12 pt-3">
                                                <inertia-link
                                                    class="font-poppins color-dark-blue"
                                                    :href="route('nl.employerdashboard.mfa.recover.index')">
                                                    <u>{{
                                                            Lang.get('employerdashboard::pages/auth/login.reset_multi_factor_authentication')
                                                        }}</u>
                                                </inertia-link>
                                            </div>
                                            <div v-else class="col-12 col-lg-8">
                                                <inertia-link
                                                    class="font-poppins color-dark-blue d-block float-none float-lg-right mt-3 mt-sm-0 pt-2"
                                                    :href="route('nl.employerdashboard.lost.password')"><u>
                                                    {{
                                                        Lang.get('employerdashboard::pages/auth/login.forgot_password')
                                                    }}</u>
                                                </inertia-link>
                                            </div>
                                        </div>
                                    </form>
                                </AuthTabPane>
                            </AuthTabPanel>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </clean-layout>
</template>

<script>
import CleanLayout from '@/Shared/CleanLayout'
import TextInput from "@/Shared/TextInput";
import FlashMessages from "@/Shared/FlashMessages";
import AuthTabPanel from "./AuthTabPanel";
import AuthTabPane from "./AuthTabPane";

export default {
    metaInfo: {
        title: Lang.get('employerdashboard::pages/auth/login.title')
    },
    components: {
        AuthTabPane,
        AuthTabPanel,
        TextInput,
        CleanLayout,
        FlashMessages
    },
    props: {
        errors: [Object, Array, null],
        resetMessage: {
            type: [String, null],
        },
        twoFactorLogin: {
            type: [Boolean, null],
        },
    },
    data() {
        return {
            form: {
                email: null,
                password: null,
                remember: null,
                code: null,
            },
        }
    },
    methods: {
        submit() {
            const _this = this;

            this.$inertia.post(this.route('nl.employerdashboard.login.attempt'), {
                email: this.form.email,
                password: this.form.password,
                remember: this.form.remember,
                code: this.form.code,
            }, {
                onSuccess() {
                    if (_this.twoFactorLogin && _this.$refs.codeInput) {
                        _this.$refs.codeInput.focus()
                    }
                }
            })
        },
    },
}
</script>
